export default {
	en: {
		currency: {
			style: 'currency',
			currency: 'EUR',
			notation: 'standard',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		currencyNoCents: {
			style: 'currency',
			currency: 'EUR',
			notation: 'standard',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		decimal: {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		percent: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
	},
	nl: {
		currency: {
			style: 'currency',
			currency: 'EUR',
			notation: 'standard',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		currencyNoCents: {
			style: 'currency',
			currency: 'EUR',
			notation: 'standard',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		decimal: {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		percent: {
			style: 'percent',
			useGrouping: false,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
	},
};
